import React from 'react';

interface IEmptyPanelIllustrationProps {
  dataTest: string;
  height?: number;
  width?: number;
}

export const EmptyPanelIllustration: React.FC<IEmptyPanelIllustrationProps> = ({ dataTest, height, width }) => {
  return (
    <svg viewBox="0 0 80 80" aria-label="empty panel" width={width} height={height} data-test={dataTest}>
      <circle cx="40.5" cy="40" r="39.5" fill="#DFE3E8" stroke="#DFE3E8" />
      <path
        d="M39.425 25.125C39.8 24.375 40.4042 24 41.2375 24C42.0708 24 42.675 24.375 43.05 25.125L47.1125 33.375L56.2375 34.75C57.0708 34.8333 57.6125 35.2708 57.8625 36.0625C58.1125 36.8542 57.9458 37.5417 57.3625 38.125L50.7375 44.5625L52.3 53.6875C52.425 54.4792 52.1542 55.1042 51.4875 55.5625C50.8208 56.0625 50.1333 56.125 49.425 55.75L41.2375 51.5L33.05 55.75C32.3417 56.1667 31.6542 56.125 30.9875 55.625C30.3208 55.125 30.05 54.4792 30.175 53.6875L31.7375 44.5625L25.1125 38.125C24.5292 37.5417 24.3625 36.8542 24.6125 36.0625C24.8625 35.2708 25.4042 34.8333 26.2375 34.75L35.3625 33.375L39.425 25.125Z"
        fill="#B5B9BD"
      />
    </svg>
  );
};
